<template>
   <div class="layout-px-spacing" v-if="
      this.$can('admin') ||
      this.$can('office') ||
      this.$can('technik-manager') ||
      this.$can('obchodnik-manager') ||
      this.$can('skladnik')
   ">
      <breadcrumb />

      <div class="row layout-top-spacing">
         <div class="col-xl-12 col-lg-12 col-sm-12 layout-spacing">
            <div class="panel p-0">
               <div class="custom-table table3">


                  <div class="table-header">
                     <h3>{{ $t("items") }}</h3>
                     <div class="header-search">
                        <a v-b-tooltip.hover :title="$t('create')" @click.prevent="add_item_modal" class="cursor-pointer">
                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-plus-circle">
                              <circle cx="12" cy="12" r="10"></circle>
                              <line x1="12" y1="8" x2="12" y2="16"></line>
                              <line x1="8" y1="12" x2="16" y2="12"></line>
                           </svg>
                        </a>
                        <div class="header-search"><input type="text" v-model.trim="search_value"
                                                          :placeholder="$t('search')" class="form-control form-control-sm" id="__BVID__321">
                           <div class="search-image">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                   fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                   stroke-linejoin="round" class="feather feather-search">
                                 <circle cx="11" cy="11" r="8"></circle>
                                 <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                              </svg>
                           </div>
                        </div>

                     </div>

                  </div>

                  <div class="table-responsive">
                     <table class="table table-items table-hover" ref="table">
                        <thead>
                           <tr>
                              <th>Id</th>
                              <th class="expanding-th">{{ $t("name") }} <span @click="expand = !expand"
                                                                              v-if="expand === true">▶</span><span @click="expand = !expand" v-else>◀</span></th>
                              <th>{{ $t("category") }}</th>
                              <th>MJ</th>
                              <th>{{ $t("note") }}</th>
                              <th>{{ $t("purchase_price") }}</th>
                              <th>{{ $t("show_in_user_list") }}</th>
                              <th class="actions text-center">{{ $t("events") }}</th>
                           </tr>
                        </thead>
                        <tbody is="transition-group">
                           <tr v-if="items.length === 0" key="empty">
                              <td colspan="8" class="text-center">{{ $t("no_items") }}</td>
                           </tr>
                           <tr v-for="item in items" :key="item.id ?? 'new'">
                              <td tabindex="0" class="">{{ item.id }}</td>
                              <td>
                                 <div v-if="item.id === null" class="form-group">
                                    <b-input :state="validateState('item_name')" v-model="$v.form.item_name.$model"
                                             :placeholder="$t('item_name')"></b-input>
                                 </div>
                                 <span v-else class="expanding-span" :class="{ 'expanding-span-toogle': expand }">
                                    <img v-if="item.attachments[0]" :src="url + '/' +  item.attachments[0].file_path" class="mr-2" style="width: 2rem; height: 2rem; object-fit: cover; border-radius: 0.3rem; cursor: pointer;" @click="openLightbox(item)" alt="" loading="lazy">
                                    <svg v-else
                                         style="width: 2rem; height: 1.6rem;" v-b-tooltip.hover
                                         viewBox="0 0 24 24" width="24" height="24"
                                         stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"
                                         stroke-linejoin="round" class="css-i6dzq1 mr-2">
                                       <path
                                         d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                                       </path>
                                       <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                                       <line x1="12" y1="22.08" x2="12" y2="12"></line>
                                    </svg>
                                    {{ item.name ?? "-" }}
                                 </span>
                              </td>
                              <td>
                                 <div v-if="item.id === null" class="form-group">
                                    <b-select :state="validateState('item_category')"
                                              v-model="$v.form.item_category.$model" :label="$t('category')">-->
                                       <b-select-option :value="null">{{ $t("category") }}</b-select-option>
                                       <b-select-option v-for="category in categories" :value="category.id"
                                                        :key="category.id">
                                          {{ category.name ?? "-" }}
                                       </b-select-option>
                                    </b-select>
                                 </div>
                                 <span v-else>
                                    {{ item.category.name }}
                                 </span>
                              </td>
                              <td>
                                 <div v-if="item.id === null" class="form-group">

                                    <b-select :state="validateState('item_unit')" v-model="$v.form.item_unit.$model">-->
                                       <b-select-option :value="null">MJ</b-select-option>
                                       <b-select-option v-for="unit in units" :value="unit.id" :key="unit.id">
                                          {{ unit.name }}
                                       </b-select-option>
                                    </b-select>
                                 </div>
                                 <span v-else>
                                    {{ item.unit.name }}
                                 </span>
                              </td>
                              <td>
                                 <div v-if="item.id === null" class="form-group">
                                    <b-input :state="validateState('item_note')" v-model="$v.form.item_note.$model"
                                             :placeholder="$t('note')"></b-input>
                                 </div>
                                 <span v-else>
                                    {{ item.note ?? "-" }}
                                 </span>
                              </td>
                              <td>
                                 <div v-if="item.id === null" class="form-group">
                                    <b-input :state="validateState('item_purchase_price')" v-model="$v.form.item_purchase_price.$model"
                                             type="number" step="0.01" :placeholder="$t('purchase_price')"></b-input>
                                 </div>
                                 <span v-else>
                                    {{ item.purchase_price ? parseFloat(item.purchase_price).toFixed(2) : "-" }}
                                 </span>
                              </td>
                              <td class="text-center">
                                 <div v-if="item.id === null" class="form-group">
                                    <b-form-checkbox v-model="$v.form.item_show_in_user_list.$model">
                                    </b-form-checkbox>
                                 </div>
                                 <span v-else>
                                    <svg v-if="item.show_in_user_list === true || item.show_in_user_list === 1 || item.show_in_user_list === '1'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
                                       <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                 </span>
                              </td>
                              <td class="action-btn text-center">
                                 <a v-if="item.id === null" href="" class="mr-1" v-b-tooltip.hover :title="$t('add')"
                                    @click.prevent="add_item()">

                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" class="feather feather-info">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="12" y1="16" x2="12" y2="12"></line>
                                       <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                    </svg>

                                 </a>
                                 <a v-else href="" class="mr-1" v-b-tooltip.hover :title="$t('edit')"
                                    @click.prevent="edit_item_modal(item.id)">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" class="feather feather-edit-2 edit">
                                       <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                                    </svg>
                                 </a>
                                 <a href="javascript:;" @click.prevent="delete_item(item.id)" v-b-tooltip.hover
                                    :title="$t('delete')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                         fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                         stroke-linejoin="round" class="feather feather-trash-2">
                                       <polyline points="3 6 5 6 21 6"></polyline>
                                       <path
                                         d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                       </path>
                                       <line x1="10" y1="11" x2="10" y2="17"></line>
                                       <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                 </a>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                     <!--                          <div class="loading-row" v-if="loading">-->
                     <!--                          </div>-->
                  </div>
                  <div class="table-footer">
                     <div v-if="items">{{ $t("it_is_displayed") }} {{ items.length }} {{ $t("of") }} {{ meta?.total }}
                     </div>
                     <div class="paginating-container pagination-solid flex-column align-items-right">
                        <b-pagination v-if="items && meta" prev-text="Prev" next-text="Next" first-text="First" last-text="Last"
                                      first-class="first" prev-class="prev" next-class="next" last-class="last" class="rounded"
                                      v-model="meta.current_page" :total-rows="meta?.total" :per-page="meta?.per_page"
                                      @change="handlePageChange">
                           <template #first-text>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                   viewBox="0 0 24 24" stroke="currentColor">
                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                       d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                              </svg>
                           </template>
                           <template #prev-text>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                   viewBox="0 0 24 24" stroke="currentColor">
                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                       d="M15 19l-7-7 7-7" />
                              </svg>
                           </template>
                           <template #next-text>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                   viewBox="0 0 24 24" stroke="currentColor">
                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                       d="M9 5l7 7-7 7" />
                              </svg>
                           </template>
                           <template #last-text>
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                   viewBox="0 0 24 24" stroke="currentColor">
                                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                       d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                              </svg>
                           </template>
                        </b-pagination>
                     </div>
                  </div>
                  <!--                 <div class="table-footer">
                                     <div v-if="items">Zobrazuje se {{ filteredData.length }} z {{ items.total }}</div>
                                     <div class="paginating-container pagination-solid flex-column align-items-right">
                                       <b-pagination
                                           v-if="items"
                                           prev-text="Prev"
                                           next-text="Next"
                                           first-text="First"
                                           last-text="Last"
                                           first-class="first"
                                           prev-class="prev"
                                           next-class="next"
                                           last-class="last"
                                           class="rounded"
                                           v-model="items.current_page"
                                           :total-rows="items.total"
                                           :per-page="items.per_page"
                                           @change="handlePageChange"
                                       >
                                         <template #first-text>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                                           </svg>
                                         </template>
                                         <template #prev-text>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                                           </svg>
                                         </template>
                                         <template #next-text>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                                           </svg>
                                         </template>
                                         <template #last-text>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                             <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                                           </svg>
                                         </template>
                                       </b-pagination>
                                     </div>
                                   </div>-->
               </div>
            </div>
         </div>
      </div>

      <!-- Modal ADD-->
      <b-modal centered id="addItemModal" :static="true" :title="$t('create_an_item')" size="md">
         <div class="add-contact-box">
            <div class="add-contact-content">
               <b-form id="addItemModalTitle">
                  <div class="row">
                     <div class="col-md-12">
                        <div class="row">
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_name')" v-model="$v.form.item_name.$model"
                                          :placeholder="$t('item_name')"></b-input>
                                    <svg @click="openTranslationModal('name')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-select :state="validateState('item_category')"
                                           v-model="$v.form.item_category.$model" :label="$t('category')">
                                    <b-select-option :value="null">{{ $t("category") }}</b-select-option>
                                    <b-select-option v-for="category in categories" :value="category.id"
                                                     :key="category.id">
                                       {{ category.name }}
                                    </b-select-option>
                                 </b-select>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-select :state="validateState('item_unit')" v-model="$v.form.item_unit.$model">
                                    <b-select-option :value="null">MJ</b-select-option>
                                    <b-select-option v-for="unit in units" :value="unit.id" :key="unit.id">
                                       {{ unit.name }}
                                    </b-select-option>
                                 </b-select>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_note')" v-model="$v.form.item_note.$model"
                                          :placeholder="$t('note')"></b-input>
                                    <svg @click="openTranslationModal('note')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_purchase_price')" v-model="$v.form.item_purchase_price.$model"
                                          type="number" step="0.01" :placeholder="$t('purchase_price')"></b-input>
                                    <svg @click="openTranslationModal('price')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-form-checkbox v-model="$v.form.item_show_in_user_list.$model">
                                    {{ $t("show_in_user_list_modal") }}
                                 </b-form-checkbox>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <p class="mb-1">{{ $t("product_image") }}</p>
                                 <upload-media ref="uploadMediaComponent" @media="(data) => save_media(data)" @updatedMedia="update_media" :maxFiles="1"></upload-media>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </b-form>
            </div>
         </div>

         <template #modal-footer>
            <b-button variant="cancel" data-dismiss="modal" @click="cancel_item">{{ $t("cancel") }}</b-button>
            <b-button :class="{ activeButton: loading }" :disabled="loading" variant="default" @click="add_item">{{
                  $t("create") }}
            </b-button>
         </template>
      </b-modal>

      <!-- Modal EDIT-->
      <b-modal centered id="editItemModal" :static="true" :title="$t('edit_an_item')" size="md">
         <div class="add-contact-box">
            <div class="add-contact-content">
               <b-form id="editItemModalTitle">
                  <div class="row">
                     <div class="col-md-12">
                        <div class="row">
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_name', false)" v-model="$v.form.item_name.$model"
                                          :placeholder="$t('item_name')"></b-input>
                                    <svg @click="openTranslationModal('name')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-select :state="validateState('item_category', false)"
                                           v-model="$v.form.item_category.$model" :label="$t('category')">
                                    <b-select-option :value="null">{{ $t("category") }}</b-select-option>
                                    <b-select-option v-for="category in categories" :value="category.id"
                                                     :key="category.id">
                                       {{ category.name }}
                                    </b-select-option>
                                 </b-select>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-select :state="validateState('item_unit', false)" v-model="$v.form.item_unit.$model">
                                    <b-select-option :value="null">MJ</b-select-option>
                                    <b-select-option v-for="unit in units" :value="unit.id" :key="unit.id">
                                       {{ unit.name }}
                                    </b-select-option>
                                 </b-select>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_note', false)" v-model="$v.form.item_note.$model"
                                          :placeholder="$t('note')"></b-input>
                                    <svg @click="openTranslationModal('note')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <div class="input-with-globe">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="flag-icon flag-sk" viewBox="0 0 32 32"><path fill="#204c9e" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#fff"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#db362f"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="#db362f"></path><path d="M10.673,19.945v-4.462c-1.511,0-1.94,.134-2.392,.27,.042-.456,.042-.915,0-1.371,.452,.137,.881,.27,2.392,.27v-1.24c-.477,0-1.135,.019-1.892,.277,.043-.457,.043-.917,0-1.374,.757,.254,1.415,.274,1.892,.274,0-.359-.111-1.132-.251-1.772,.436,.039,.874,.039,1.31,0-.14,.639-.251,1.412-.251,1.772,.477,0,1.135-.019,1.892-.274-.043,.457-.043,.917,0,1.374-.757-.258-1.415-.277-1.892-.277v1.24c1.511,0,1.94-.134,2.392-.27-.042,.456-.042,.915,0,1.371-.452-.137-.881-.27-2.392-.27v4.462h-.808Z" fill="#fff"></path><path d="M15.65,10.232s.178,1.784,.178,5.353c-.025,3.645-2.751,5.49-4.752,6.46-2.001-.97-4.726-2.815-4.752-6.46,0-3.569,.178-5.353,.178-5.353H15.65Z" fill="none"></path><path d="M11.076,22.044c1.241-.602,2.761-1.542,3.742-3.038-.007-.014-.011-.031-.017-.045-.56-1.184-1.576-1.367-2.268-.409-.089-.209-.191-.399-.304-.565-.805-1.181-1.973-.929-2.609,.565-.287-.397-.645-.614-1.014-.614-.518,0-.973,.424-1.268,1.072,.982,1.494,2.499,2.432,3.739,3.034Z" fill="#204c9e"></path><path d="M11.076,22.235l-.075-.036c-1.348-.654-2.385-1.395-3.169-2.266-1.103-1.225-1.668-2.687-1.679-4.347,0-3.537,.177-5.353,.179-5.371l.015-.155H15.806l.015,.155c.002,.018,.179,1.834,.179,5.37-.012,1.661-.577,3.123-1.679,4.348-.785,.871-1.821,1.613-3.169,2.266l-.075,.036ZM6.66,10.404c-.041,.505-.164,2.246-.164,5.181,.011,1.572,.546,2.958,1.591,4.118,.74,.822,1.718,1.526,2.989,2.151,1.271-.625,2.249-1.329,2.989-2.151,1.045-1.16,1.58-2.546,1.591-4.119,0-2.934-.122-4.675-.164-5.18H6.66Z" fill="#fff"></path></svg>
                                 <b-input :state="validateState('item_purchase_price', false)" v-model="$v.form.item_purchase_price.$model"
                                          type="number" step="0.01" :placeholder="$t('purchase_price')"></b-input>
                                    <svg @click="openTranslationModal('price')" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-globe globe-icon">
                                       <circle cx="12" cy="12" r="10"></circle>
                                       <line x1="2" y1="12" x2="22" y2="12"></line>
                                       <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                                    </svg>
                                 </div>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <b-form-checkbox v-model="$v.form.item_show_in_user_list.$model">
                                    {{ $t("show_in_user_list_modal") }}
                                 </b-form-checkbox>
                              </div>
                           </div>
                           <div class="col-12">
                              <div class="form-group">
                                 <p class="mb-1">{{ $t("product_image") }}</p>
                                 <update-media ref="updateMediaComponent" :file="media_files" @added-media="added_media" @deleted-media="deleted_media" :media_file_path="url" :maxFiles="1"></update-media>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </b-form>
            </div>
         </div>

         <template #modal-footer>
            <b-button variant="cancel" data-dismiss="modal" @click="cancel_item">{{ $t("cancel") }}</b-button>
            <b-button :class="{ activeButton: loading }" :disabled="loading" variant="default" @click.prevent="edit_item">
               Upraviť
            </b-button>
         </template>
      </b-modal>

      <!-- Translation Modals -->
      <b-modal centered id="translationModal" :static="true" :title="translationModalTitle" size="md">
         <div class="add-contact-box">
            <div class="add-contact-content">
               <div class="row">
                  <div class="col-12">
                     <!-- Czech Translation -->
                     <div class="mb-3">
                        <div class="input-with-flag">
                           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" class="flag-icon flag-cz">
                              <path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#c62d25"></path>
                              <path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path>
                              <path d="M2.316,26.947l13.684-10.947L2.316,5.053c-.803,.732-1.316,1.776-1.316,2.947V24c0,1.172,.513,2.216,1.316,2.947Z" fill="#1e427b"></path>
                           </svg>
                           <b-input v-if="currentTranslationType === 'name'" v-model="form.translations.cz.name" :placeholder="$t('item_name') + ' (' + $t('cz') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'note'" v-model="form.translations.cz.note" :placeholder="$t('note') + ' (' + $t('cz') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'price'" v-model="form.translations.cz.price" type="number" step="0.01" :placeholder="$t('purchase_price') + ' (' + $t('cz') + ')'"></b-input>
                        </div>
                     </div>
                     
                     <!-- Hungarian Translation -->
                     <div class="mb-3">
                        <div class="input-with-flag">
                           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" class="flag-icon flag-hu">
                              <path fill="#fff" d="M1 11H31V21H1z"></path>
                              <path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#be373c"></path>
                              <path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#4f6f52"></path>
                           </svg>
                           <b-input v-if="currentTranslationType === 'name'" v-model="form.translations.hu.name" :placeholder="$t('item_name') + ' (' + $t('hu') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'note'" v-model="form.translations.hu.note" :placeholder="$t('note') + ' (' + $t('hu') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'price'" v-model="form.translations.hu.price" type="number" step="0.01" :placeholder="$t('purchase_price') + ' (' + $t('hu') + ')'"></b-input>
                        </div>
                     </div>
                     
                     <!-- Polish Translation -->
                     <div class="mb-3">
                        <div class="input-with-flag">
                           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" class="flag-icon flag-pl">
                              <path d="M1,24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V15H1v9Z" fill="#cb2e40"></path>
                              <path d="M27,4H5c-2.209,0-4,1.791-4,4v8H31V8c0-2.209-1.791-4-4-4Z" fill="#fff"></path>
                           </svg>
                           <b-input v-if="currentTranslationType === 'name'" v-model="form.translations.pl.name" :placeholder="$t('item_name') + ' (' + $t('pl') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'note'" v-model="form.translations.pl.note" :placeholder="$t('note') + ' (' + $t('pl') + ')'"></b-input>
                           <b-input v-if="currentTranslationType === 'price'" v-model="form.translations.pl.price" type="number" step="0.01" :placeholder="$t('purchase_price') + ' (' + $t('pl') + ')'"></b-input>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <template #modal-footer>
            <b-button variant="cancel" data-dismiss="modal" @click="closeTranslationModal">{{ $t("cancel") }}</b-button>
            <b-button variant="default" @click="closeTranslationModal">{{ $t("save") }}</b-button>
         </template>
      </b-modal>

      <vue-easy-lightbox
        :visible="lightboxVisible"
        :imgs="[lightboxUrl]"
        @hide="lightboxVisible = false"
      />

   </div>
   <div class="layout-px-spacing d-flex align-items-center justify-content-center" v-else>
      <div class="row layout-top-spacing">
         <div class="col-12">
            <h4 class="text-center px-3">{{ $t("not_allowed") }}</h4>
         </div>
      </div>
   </div>
</template>

<script>
   import "../../assets/sass/global/table.scss";
   import { validationMixin } from "vuelidate";
   import { required } from "vuelidate/lib/validators";
   import { mapState } from "vuex";
   import _debounce from "lodash/debounce";
   import uploadMedia from "@/components/file_uploads/UploadMedia.vue";
   import updateMedia from "@/components/file_uploads/UpdateMedia.vue";
   import { urlMixin } from "@/mixins/url";

   export default {
      components: { uploadMedia, updateMedia },
      mixins: [validationMixin, urlMixin],
      validations: {
         form: {
            item_name: {
               required
            },
            item_category: {
               required
            },
            item_unit: {
               required
            },
            item_note: {},
            item_purchase_price: {},
            item_show_in_user_list: {}
         }
      },
      data() {
         return {
            per_page: 100,
            search_value: "",
            page: 1,
            options: [
               { value: "5", text: "5" },
               { value: "10", text: "10" },
               { value: "20", text: "20" },
               { value: "50", text: "50" }
            ],
            form: {
               item_id: "",
               item_name: "",
               item_category: null,
               item_unit: null,
               item_note: "",
               item_purchase_price: null,
               item_show_in_user_list: false,
               item_images: null,
               translations: {
                  cz: { name: "", note: "", price: "" },
                  hu: { name: "", note: "", price: "" },
                  pl: { name: "", note: "", price: "" }
               }
            },
            currentTranslationType: null, // 'name', 'note', or 'price'
            categories: {},
            units: {},
            expand: false,
            media_files: [],
            lightboxVisible: false,
            lightboxUrl: ""
         };
      },
      watch: {
         search_value: {
            handler: _debounce(function() {
               this.fetchData();
            }, 250),
            immediate: false
         },
         per_page() {
            if (this.per_page > this.meta.total) {
               this.page = 1;
            }
            this.fetchData();
         }
      },
      created() {
         this.fetchData();
         this.$axios.get("item_categories")
           .then(response => {
              this.categories = response.data;
           });
         this.$axios.get("units")
           .then(response => {
              this.units = response.data;
           });
      },
      computed: {
         meta() {
            return this.$store.state.item.items_meta;
         },
         items() {
            return this.$store.state.item.items;
         },
         translationModalTitle() {
            if (this.currentTranslationType === 'name') {
               return this.$t('item_name') + ' - ' + this.$t('translations');
            } else if (this.currentTranslationType === 'note') {
               return this.$t('note') + ' - ' + this.$t('translations');
            } else if (this.currentTranslationType === 'price') {
               return this.$t('purchase_price') + ' - ' + this.$t('translations');
            }
            return this.$t('translations');
         },
         ...mapState("loader", ["loading"])
      },
      methods: {
         openTranslationModal(type) {
            this.currentTranslationType = type;
            this.$bvModal.show('translationModal');
         },
         closeTranslationModal() {
            this.$bvModal.hide('translationModal');
            this.currentTranslationType = null;
         },
         fetchData() {
            this.$store.dispatch("item/getItems", {
               page: this.page,
               per_page: this.per_page,
               search_value: this.search_value
            });
         },
         handlePageChange(value) {
            this.page = value;
            this.fetchData();
         },
         update_media(media) {
            this.form.item_images = media;
         },
         save_media(data) {
            this.form.item_images = data;
         },
         added_media(data) {
            this.form.added_files = data;
         },
         deleted_media(data) {
            this.form.deleted_files = data;
         },
         openLightbox(item) {
            this.lightboxUrl = this.url + "/" + item.attachments[0].file_path;
            this.lightboxVisible = true;
         },
         validateState(name, adding = true) {
            const { $dirty, $error } = adding ? this.$v.form[name] : this.$v.form[name];
            return $dirty ? !$error : null;
         },
         // scrollToLastRow() {
         //
         //   const rows = this.$refs.table.querySelector('tbody').querySelectorAll('tr')
         //   const row = rows[rows.length - 1]
         //   row.scrollIntoView(true)
         // },
         add_item_modal() {

            //if exists item where id== null, disable adding
            if (!this.$store.state.item.items.find(x => x.id == null)) {
               // this.$store.state.item.items.push({
               //   id: null,
               //   name: "",
               //   category: '',
               //   unit: '',
               //   note: ""
               // });
               this.form.item_id = "";
               this.form.item_name = "";
               this.form.item_category = null;
               this.form.item_unit = null;
               this.form.item_note = "";
               this.form.item_purchase_price = null;
               this.form.item_show_in_user_list = false;
               this.form.translations = {
                  cz: { name: "", note: "", price: "" },
                  hu: { name: "", note: "", price: "" },
                  pl: { name: "", note: "", price: "" }
               };
               this.$v.$reset();
               this.$refs.uploadMediaComponent?.reset();
               this.form.item_images = null;
               this.$bvModal.show("addItemModal");

            }


            // this.$bvModal.show("addItemModal");
         },
         edit_item_modal(id) {
            /* this.$axios.get("items/"+id)
                 .then((response) => {
                   this.form.item_id = response.data.id;
                   this.form.item_name = response.data.name;
                   this.form.item_category = response.data.item_category_id;
                   this.form.item_unit = response.data.unit_id;
                   this.form.item_note = response.data.note;
                 });
             */

            const itemData = this.items.find(x => x.id === id);

            this.form.added_files = [];
            this.form.deleted_files = [];

            this.form.item_id = itemData.id;
            this.form.item_name = itemData.name_original || itemData.name;
            this.form.item_category = itemData.category.id;
            this.form.item_unit = itemData.unit.id;
            this.form.item_note = itemData.note_original || itemData.note;
            this.form.item_purchase_price = itemData.purchase_price_original || itemData.purchase_price;
            this.form.item_show_in_user_list = !!(itemData.show_in_user_list === true || itemData.show_in_user_list === 1 || itemData.show_in_user_list === '1');
            
            // Load translations
            this.form.translations = {
               cz: { name: "", note: "", price: "" },
               hu: { name: "", note: "", price: "" },
               pl: { name: "", note: "", price: "" }
            };
            
            if (itemData.translations && Array.isArray(itemData.translations)) {
               itemData.translations.forEach(translation => {
                  if (this.form.translations[translation.locale] && translation.translations) {
                     // Load translations from JSON object
                     this.form.translations[translation.locale] = {
                        name: translation.translations.name || "",
                        note: translation.translations.note || "",
                        price: translation.translations.price ? parseFloat(translation.translations.price) : ""
                     };
                  }
               });
            }
            
            this.$refs.updateMediaComponent?.reset();

            this.media_files = itemData.attachments.map((a) => ({
               name: a.file_path,
               url: this.url + "/" + a.file_path
            }));

            this.$bvModal.show("editItemModal");

         },
         cancel_item() {
            this.$bvModal.hide("addItemModal");
            this.$bvModal.hide("editItemModal");
         },
         add_item() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
               this.$toast.error(this.$t("missing_credentials"));
               return;
            }

            let data = {
               name: this.form.item_name,
               item_category_id: this.form.item_category,
               unit_id: this.form.item_unit,
               note: this.form.item_note,
               purchase_price: this.form.item_purchase_price ? parseFloat(this.form.item_purchase_price) : null,
               show_in_user_list: !!this.form.item_show_in_user_list,
               added_media: this.form.item_images?.map(f => f.name),
               translations: this.form.translations
            };

            // this.$store.dispatch("loader/pending");
            this.$axios.post("items", data)
              .then((response) => {
                 // this.$bvModal.hide("addItemModal");
                 this.$store.dispatch("item/getItems", {
                    page: this.page,
                    per_page: this.per_page,
                    search_value: this.search_value
                 });
                 // try {

                 // let formItem = this.$store.state.item.items.find(x => x.id == null); // cez tuto premennu mi to nechcelo prekreslit
                 // this.$store.state.item.items.find(x => x.id == null).name = response.data.item.name;
                 // this.$store.state.item.items.find(x => x.id == null).category = response.data.item.category;
                 // this.$store.state.item.items.find(x => x.id == null).unit = response.data.item.unit;
                 // this.$store.state.item.items.find(x => x.id == null).note = response.data.item.note;
                 // this.$store.state.item.items.find(x => x.id == null).id = response.data.item.id;
                 // formItem.id = response.data.item.id;
                 // formItem.name = response.data.item.name;
                 // formItem.category = response.data.item.item_category;
                 // formItem.unit = response.data.item.unit;
                 // formItem.note = response.data.item.note;

                 this.$bvModal.hide("addItemModal");
                 this.$toast.success(response.data.message);
                 // this.$store.dispatch("loader/done");
                 // } catch (e) {
                 //   console.log(e)
                 // }
              })
              .catch(response => {
                 this.$toast.error(response.response.data.message);
              });
         },
         edit_item() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
               this.$toast.error(this.$t("missing_credentials"));
               return;
            }

            let data = {
               item_id: this.form.item_id,
               name: this.form.item_name,
               item_category_id: this.form.item_category,
               unit_id: this.form.item_unit,
               note: this.form.item_note,
               purchase_price: this.form.item_purchase_price ? parseFloat(this.form.item_purchase_price) : null,
               show_in_user_list: !!this.form.item_show_in_user_list,
               added_media: this.form.added_files?.map(f => f.name),
               deleted_media: this.form.deleted_files?.map(f => f.name),
               translations: this.form.translations
            };

            this.$axios.put(`items/${this.form.item_id}`, data)
              .then((response) => {
                 if (response !== undefined) {
                    this.$bvModal.hide("editItemModal");
                    this.$store.dispatch("item/getItems", {
                       page: this.page,
                       per_page: this.per_page,
                       search_value: this.search_value
                    });
                    this.$toast.success(response.data.message);
                 } else {
                    this.$toast.error(this.$t("match_find"));
                 }
              })
              .catch(response => {
                 this.$toast.error(response.response.data.message);
              });
         },
         delete_item(id) {
            if (id === null) {
               this.$store.state.item.items.pop();
            } else if (window.confirm(this.$t("confirm_delete"))) {
               this.$axios.delete(`items/${id}`)
                 .then((response) => {
                    this.$store.dispatch("item/getItems");
                    this.$toast.success(response.data.message);
                 }).catch(error => {
                  this.$toast.error(error.data.error);
               });
            }
         }
      }
   };
</script>

<style scoped lang="scss">
   .input-with-globe {
      position: relative;
      display: flex;
      align-items: center;
      
      .flag-icon {
         position: absolute;
         left: 10px;
         z-index: 10;
         border-radius: 2px;
      }
      
      .globe-icon {
         position: absolute;
         right: 10px;
         z-index: 10;
         cursor: pointer;
         color: #6c757d;
         transition: color 0.2s;
         
         &:hover {
            color: #007bff;
         }
      }
      
      :deep(.form-control) {
         padding-left: 40px;
         padding-right: 40px;
      }
   }
   
   .input-with-flag {
      position: relative;
      display: flex;
      align-items: center;
      
      .flag-icon {
         position: absolute;
         left: 10px;
         z-index: 10;
         border-radius: 2px;
      }
      
      :deep(.form-control) {
         padding-left: 40px;
      }
   }
</style>

<!--<style lang="scss">-->
<!--  @-webkit-keyframes moving-gradient {-->
<!--    0% { background-position: -250px 0; }-->
<!--    100% { background-position: 250px 0; }-->
<!--  }-->

<!--  .loading-row {-->

<!--      width: 100%;-->
<!--      height: 50px;-->
<!--      background: linear-gradient(to right, #eee 20%, #ddd 50%, #eee 80%);-->
<!--      background-size: 500px 100px;-->
<!--      animation-name: moving-gradient;-->
<!--      animation-duration: 1s;-->
<!--      animation-iteration-count: infinite;-->
<!--      animation-timing-function: linear;-->
<!--      animation-fill-mode: forwards;-->

<!--  }-->
<!--</style>-->

<style scoped>
   .table {
      white-space: nowrap;
   }

   .active-status {
      content: "";
      position: absolute;
      bottom: 7%;
      right: -4%;
      width: 30%;
      height: 30%;
      border-radius: 50%;
      border: 2px solid #fff;
      background-color: #1abc9c;
   }

   .usr-img-frame {
      position: relative;
   }


   .table-header h3 {
      margin-bottom: 0.6rem;

      @media (max-width: 576px) {
         margin-bottom: 1.2rem;
      }
   }
</style>
